module.exports = "<button type=\"button\" ng-click=\"$ctrl.toggleTooltip()\" ga-track-event=\"['Input Tooltip', 'Click', 'Show {{ $ctrl.name | translate | escapeSingleQuote }}']\">\n</button>\n<tooltip show=\"$ctrl.showTooltip\"\n         text=\"$ctrl.text\"\n         name=\"$ctrl.name\">\n</tooltip>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/input-tooltip/input-tooltip.html
// module id = 654
// module chunks = 0